import Pipeline from '../Pipeline';
import Select from '../Select';
import Button from '../Button';
import React from 'react';
var options = [{
  value: 'myAlgoWallet',
  label: 'MyAlgo'
}, {
  value: 'WalletConnect',
  label: 'WalletConnect'
}, {
  value: 'AlgoSigner',
  label: 'AlgoSigner'
}];

var MultiWalletConnect = function MultiWalletConnect(props) {
  function walletChanged(event) {
    Pipeline.pipeConnector = event.value;
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    id: "walletswitch",
    placeholder: "Select a Wallet",
    onChange: function onChange(event) {
      return walletChanged(event);
    },
    options: options
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      Pipeline.connect(props.wallet).then(function (accounts) {
        if (props.returnTo !== undefined) {
          var data = {};
          data[props.returnTo] = accounts;
          props.context.setState(data);
        }

        if (typeof props.onChange === 'function') {
          props.onChange(accounts);
        }
      });
    }
  }, "Connect"));
};

export default MultiWalletConnect;